var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.currentSegmentIndex != null
    ? _c("div", [
        _c("div", { staticClass: "navigation-window" }, [
          _c(
            "div",
            { staticClass: "icons" },
            [
              _c("fa", {
                staticClass: "prev fa-1-5x",
                class: { disabled: _vm.isPrevDisabled },
                attrs: {
                  icon: ["far", "circle-left"],
                  size: "lg",
                  title: "Previous Segment",
                },
                on: {
                  click: function ($event) {
                    !_vm.isPrevDisabled && _vm.nextPrevANSISegment(false)
                  },
                },
              }),
              _vm._v(" "),
              _c("fa", {
                staticClass: "last",
                class: { disabled: !_vm.hasPrevAnsiSegment() },
                attrs: {
                  icon: ["fas", "search"],
                  size: "1x",
                  title: "Last Segment",
                },
                on: {
                  click: function ($event) {
                    return _vm.lastANSISegment()
                  },
                },
              }),
              _vm._v(" "),
              _c("fa", {
                staticClass: "next fa-1-5x",
                class: { disabled: _vm.isNextDisabled },
                attrs: {
                  icon: ["far", "circle-right"],
                  size: "lg",
                  title: "Next Segment",
                },
                on: {
                  click: function ($event) {
                    !_vm.isNextDisabled && _vm.nextPrevANSISegment(true)
                  },
                },
              }),
              _vm._v(" "),
              _vm.btnLabels.length > 0 &&
              _vm.btnLayers &&
              _vm.layerDefinition != "BIASED"
                ? _c("MMP_ANSI_LayerShortcuts", {
                    attrs: {
                      btnLabels: _vm.btnLabels,
                      btnLayers: _vm.btnLayers,
                      activeLayers: _vm.map.getLayers().getArray(),
                      ansiLayersButtonCtrl: _vm.ansiLayersButtonCtrl,
                    },
                    on: {
                      toggleLayer: function ($event) {
                        return _vm.$emit("toggleLayer", $event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "segment-label-window",
            class: _vm.getSegmentLabelClass(),
            attrs: { id: "segment_label" },
          },
          [
            _c("div", [
              _vm._v(
                "SEGMENT ID = " +
                  _vm._s(_vm.ansiSegments[_vm.currentSegmentIndex].ansi_id)
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }